import { Grid, Typography } from '@mui/material';
import { InducteeOption } from '../../../../../constants/InductionEntry';
import {
	SafetyCourseStatus,
	safetyCourseTypeNames,
	SafetyCourseValidationResponse,
} from '../../../../../constants/SafetyCourse';
import { SafetyCourseValidationInfo } from '../../../SafetyCourses/SafetyCourseStatusInfo/SafetyCourseStatusInfo';

export type NewInductionReviewProps = {
	inducteeOption: InducteeOption;
	inducteeName: string;
	site: string;
	company: string;
	mobileNumber?: string;
	safetyCourseStatus?: SafetyCourseStatus;
	safetyCourse?: SafetyCourseValidationResponse | null;
};

export const NewInductionReview = ({
	inducteeOption,
	inducteeName,
	site,
	company,
	mobileNumber,
	safetyCourseStatus,
	safetyCourse,
}: NewInductionReviewProps): JSX.Element => {
	return (
		<Grid container>
			<Grid xs={6} item>
				<Typography variant="h5Bold">{inducteeOption}</Typography>
				<Typography variant="subtitle2" color="neutral.main">
					{inducteeName}
				</Typography>
				{mobileNumber !== '' && (
					<Typography variant="subtitle2" color="neutral.main">
						{mobileNumber}
					</Typography>
				)}
				<Typography variant="subtitle2" color="neutral.main">
					{company}
				</Typography>
				<Typography variant="subtitle2" color="neutral.main">
					{site}
				</Typography>
			</Grid>
			{safetyCourse && safetyCourseStatus && (
				<>
					<Grid xs={6} item>
						<Typography variant="h5Bold">Safety Course</Typography>
						<Typography variant="subtitle2" color="neutral.main">
							{safetyCourseTypeNames[safetyCourse.type]}
						</Typography>
						<Typography variant="subtitle2" color="neutral.main">
							{safetyCourse.id}
						</Typography>
					</Grid>
					<Grid
						xs={12}
						display="flex"
						alignItems="center"
						pt={2}
						item>
						<SafetyCourseValidationInfo
							status={safetyCourseStatus}
							safetyCourse={safetyCourse ?? null}
						/>
					</Grid>
				</>
			)}
		</Grid>
	);
};
